import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPayloadSummary(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        targetLoad,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
      }

      if (targetLoad !== null && targetLoad !== undefined && targetLoad !== '' && Number(targetLoad) > 0) {
        params.targetLoad = Number(targetLoad)
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload/summary', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchPayloadAggregations(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        groupBy = 'Hour',
        targetLoad,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
        groupBy,
      }

      if (targetLoad !== null && targetLoad !== undefined && targetLoad !== '' && Number(targetLoad) > 0) {
        params.targetLoad = Number(targetLoad)
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload/aggregations', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchPayloadDetails(ctx, queryParams) {
      const {
        assetId,
        startDate,
        endDate,
        page = 1,
        perPage = 50,
        targetLoad,
      } = queryParams

      const params = {
        assetId,
        startDate,
        endDate,
        page,
        perPage,
      }

      if (targetLoad !== null && targetLoad !== undefined && targetLoad !== '' && Number(targetLoad) > 0) {
        params.targetLoad = Number(targetLoad)
      }

      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/queries/telemetry/payload/details', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchAssets(ctx, queryParams) {
      const { q = '', page = 1, perPage = 10 } = queryParams
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/Asset/search?Search=${encodeURIComponent(q)}&Page=${page}&PerPage=${perPage}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchAsset(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/Asset?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
